import axios from 'axios'

export async function obterArquivoAutenticado (endpoint, path, options = {}) {
  const { data } = await axios.get(endpoint, {
    ...options,
    params: { param: String(path).replace(/\\/g, '/'), t: Date.now() },
    responseType: 'blob'
  })
  return data
}

export async function abrirArquivoAutenticado (endpoint, path) {
  if (!path) return
  // Abre durante o clique para não ser bloqueado após a requisição assíncrona.
  const aba = window.open('about:blank', '_blank')
  if (!aba) throw new Error('Permita a abertura de uma nova aba para visualizar o documento.')
  aba.opener = null
  try {
    const arquivo = await obterArquivoAutenticado(endpoint, path)
    if (aba.closed) return
    const url = URL.createObjectURL(arquivo)
    aba.location.replace(url)
    setTimeout(() => URL.revokeObjectURL(url), 60000)
  } catch (error) {
    if (!aba.closed) aba.close()
    throw new Error('Não foi possível abrir o documento. Verifique sua sessão e tente novamente.')
  }
}
